import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";
import { Canvas } from "react-three-fiber";
import Pokeball from "./components/Pokeball3D/Pokeball3D";
import styles from "./NotFound.module.scss";
import { OrbitControls } from "@react-three/drei";

const NotFound = ({ mainError }: { mainError: boolean }) => {
  return mainError ? (
    <div className={`${styles.notFoundContainer} d-flex flex-column`}>
      {mainError && <Header />}
      <div
        className={`${styles.notFound} d-flex flex-column justify-content-center align-items-center`}
        style={{ color: "white" }}
      >
        <Canvas camera={{ position: [0, 0, 60] }}>
          <ambientLight />
          <pointLight position={[10, 10, 10]} />
          <Pokeball />
          <OrbitControls />
        </Canvas>{" "}
        <h1>404 - Page Not Found</h1>
        <p>The page you are looking for does not exist.</p>
      </div>
      {mainError && <Footer />}
    </div>
  ) : (
    <div
      className={`${styles.notFound} d-flex flex-column justify-content-center align-items-center`}
    >
      <Canvas camera={{ position: [0, 0, 60] }}>
        <ambientLight />
        <pointLight position={[10, 10, 10]} />
        <Pokeball />
        <OrbitControls />
      </Canvas>{" "}
      <h1>404 - Page Not Found</h1>
      <p>Too bad, it seems like this Pokemon doesn't exist.</p>
    </div>
  );
};

export default NotFound;
